<template>
  <div
    class="team-banner"
    @click="()=>{goToPlace(site)}"
    v-bind:style="{ backgroundImage: 'url(' + photo + ')' , width:'100%', height:resizeHeight}"
    v-on:keyup.enter="()=>{goToPlace(site)}"
    v-resize="onResize"
    tabindex="0"
    aria-label="Baner"
    ref="tile"
  >
  </div>
</template>

<script>
import mixin from '../mixin';
import resize from 'vue-resize-directive'

export default {
  mixins: [mixin],
  data(){
    return {
      height: '8.125rem'
    }
  },
  computed: {
    resizeHeight() {
      return this.height;
    }
  },
  methods: {
    onResize(){
      this.height = `${(this.$refs.tile.offsetWidth)/3.6}px`;
    }
  },
  directives: {
    resize
  }
}
</script>

<style scoped lang="scss">
  .team-banner {
    background-position: center;
    height: 130px;
    background-repeat: no-repeat;
    margin: 1rem 0 0 0;
    cursor: pointer;
  }
</style>
